import React, { useState } from "react";

interface IListItem {
  item: TodoType;
  toggleTodo: ToggleFn;
  deleteTodo: DeleteFn;
  editTodo: EditFn;
  index: number;
}

const TodoListItem = ({
  item,
  toggleTodo,
  deleteTodo,
  editTodo,
  index,
}: IListItem) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState(item.task);

  const handleEdit = () => {
    if (editText.trim() !== "" && editText !== item.task) {
      editTodo(item.id, editText);
    }
    setIsEditing(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleEdit();
    } else if (e.key === "Escape") {
      setEditText(item.task);
      setIsEditing(false);
    }
  };

  const getPriorityBadge = (priority: string) => {
    const badges = {
      low: { emoji: "🟢", text: "Low", class: "priority-low" },
      medium: { emoji: "🟡", text: "Medium", class: "priority-medium" },
      high: { emoji: "🔴", text: "High", class: "priority-high" },
    };
    return (
      badges[priority as keyof typeof badges] || {
        emoji: "🟡",
        text: "Medium",
        class: "priority-medium",
      }
    );
  };

  const priorityBadge = getPriorityBadge(item.priority);

  return (
    <li className="todo-item" style={{ animationDelay: `${index * 0.1}s` }}>
      <input
        type="checkbox"
        className="todo-checkbox"
        checked={item.isDone}
        onChange={() => toggleTodo(item)}
        title={item.isDone ? "Mark as incomplete" : "Mark as complete"}
      />

      <span
        className={`priority-badge ${priorityBadge.class}`}
        title={priorityBadge.text}>
        {priorityBadge.emoji}
      </span>

      {isEditing ? (
        <input
          className="edit-input"
          type="text"
          value={editText}
          onChange={(e) => setEditText(e.target.value)}
          onBlur={handleEdit}
          onKeyDown={handleKeyPress}
          autoFocus
        />
      ) : (
        <div className="todo-content" onDoubleClick={() => setIsEditing(true)}>
          {item.isDone ? (
            <p className="checked">{item.task}</p>
          ) : (
            <p>{item.task}</p>
          )}
        </div>
      )}

      <div className="todo-actions">
        {!isEditing && (
          <button
            type="button"
            className="task-icons edit-icon"
            onClick={(event) => {
              event.stopPropagation();
              setIsEditing(true);
            }}
            title="Edit todo">
            ✏️
          </button>
        )}
        <button
          type="button"
          className="task-icons delete-icon"
          onClick={(event) => {
            event.stopPropagation();
            void deleteTodo(item.id);
          }}
          title="Delete todo">
          ❌
        </button>
      </div>
    </li>
  );
};

export default TodoListItem;
